let w_lang,
    w_resizeTimer;

const w_base = '/',
      w_myScreen = {},
      w_myBrowser = {
        engine: '',
        version: 0,
        os: ''
      };

window.addEventListener('DOMContentLoaded',function()
{
    if(document.location.hash && document.body.querySelector(document.location.hash))
    {
        document.body.querySelector(document.location.hash).scrollIntoView();
    }

    // get language from HTML
    w_lang = document.documentElement.lang;

    // load polyfills for old browsers
    if(!('Promise' in window))
    {
        const myLibrary = document.createElement('script');
        myLibrary.src = w_base + 'lib/polyfills.js';
        document.head.appendChild(myLibrary);
    }

    // add datepicker polyfill for browsers without native support
    const test = document.createElement('input');
    test.setAttribute('type','date');
    if(test.type !== 'date')
    {
        const myLibrary = document.createElement('script');
        myLibrary.src = w_base + 'lib/polyfill_inputdate.js';
        document.head.appendChild(myLibrary);
    }

    // get os, browser engine and version
    get_browser();

    // get screen size
    get_screenSize(true);

    // scrollpos
    let scrollPosY = 0;

    // add event listener
    document.body.addEventListener('click',e =>
    {
        let el = e.target;

        if(el.closest('.w__js-button'))
        {
            el = el.closest('.w__js-button');
        }

        if(el.classList.contains('w__mobile--menu-button'))
        {
            e.preventDefault();
            if(document.body.classList.contains('w__mobile--menu-active'))
            {
                document.body.classList.remove('w__mobile--menu-active');
                window.scrollTo(0, scrollPosY);
            }
            else
            {
                scrollPosY = window.scrollY;
                document.body.classList.add('w__mobile--menu-active');
            }
        }
        else if(el.classList.contains('w__js-button'))
        {
            switch(el.dataset.f)
            {
                case 'info':
                    e.preventDefault();
                    Load.get_info(el)
                    break;

                case 'lightbox':
                    e.preventDefault();
                    new Lightbox(el, el.dataset.type);
                    break;

                case 'lightbox-close':
                    e.preventDefault();
                    Lightbox.close();
                    break;

                case 'open-lang-menu':
                    let clickedEl = e.target;
                    if(clickedEl.closest('.w__lang'))
                    {
                        clickedEl = clickedEl.closest('.w__lang');
                    }
                    if(w_myScreen.layout === 'smartphone' && clickedEl.classList.contains('w__lang'))
                    {
                        if(!el.classList.contains('active') ||
                           clickedEl.classList.contains('active'))
                        {
                            e.preventDefault();
                        }
                        el.classList.toggle('active')
                    }
                    break;

                case 'play-video':
                    e.preventDefault();
                    show_video(el);
                    break;

                case 'reset-form':
                    e.preventDefault();
                    reset_form(el);
                    break;

                case 'search-category-now':
                    e.preventDefault();
                    const mySearch = new Search();
                    mySearch.search();
                    break;

                default:
                    alert("Unbekannte Funktion: " + el.dataset.f);
            }
        }
        else if(w_myScreen.layout !== 'desktop' && el.closest('.w__menu--main'))
        {
            document.body.classList.remove('w__mobile--menu-active');
        }
    });
});

const reset_form = function(el)
{
    const myForm = el.closest('form');
    if(myForm)
    {
        const inputs = myForm.querySelectorAll('.w__input--text,.w__input--select');
        for(let i=0; i<inputs.length; i++)
        {
            inputs[i].value = inputs[i].classList.contains('w__input--select') ? '0' : '';
        }
    }
};

class Load
{
    static do_request(myData)
    {
        if(myData.f)
        {
            document.documentElement.classList.add('w__waiting');
            myData.randomData = new Date().getTime();

            return new Promise(function(resolve, reject)
            {
                if(!myData.url)
                {
                    document.documentElement.classList.remove('w__waiting');
                    reject({error: 'same path'});
                }

                const myRequest = new XMLHttpRequest();
                myRequest.onreadystatechange = () =>
                {
                    if(myRequest.readyState === 4)
                    {
                        document.documentElement.classList.remove('w__waiting');
                        if(myRequest.status === 200 && myRequest.response)
                        {
                            let r = (typeof myRequest.response === 'string')
                                ? JSON.parse(myRequest.response) // fix for IE 11 that doesn't honor responseType
                                : myRequest.response;

                            if(r['ok'] === 'OK')
                            {
                                resolve(r);
                            }
                            else
                            {
                                reject(r);
                            }
                        }
                        else
                        {
                            reject({error: myRequest.status});
                        }
                    }
                };

                myRequest.onerror = () =>
                {
                    document.documentElement.classList.remove('w__waiting');
                    reject({error: 'undefined error'});
                };

                myRequest.ontimeout = () =>
                {
                    document.documentElement.classList.remove('w__waiting');
                    reject({error: 'timeout'});
                };

                myRequest.open("POST",w_base + 'index.php');
                myRequest.timeout = 10000;
                myRequest.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=utf-8");
                myRequest.setRequestHeader("Accept","application/json");
                myRequest.responseType = 'json';
                myRequest.send('json=' + encodeURIComponent(JSON.stringify(myData)));
            });
        }
    }

    static get_info(el)
    {
        const parentEl = el.closest('.w__module--article-nav');
        Load.do_request({f: 'info', url: el.href}).then(r => {
            let textContainer = document.body.querySelector('.w__article--nav-content');
            const activeTab = parentEl.querySelector('.w__article--nav-ul li.active');
            if(activeTab)
            {
                activeTab.classList.remove('active');
            }
            el.closest('li').classList.add('active');
            if(!textContainer)
            {
                textContainer = document.createElement('div');
                textContainer.classList.add('w__article--nav-content');
                parentEl.appendChild(textContainer);
            }
            textContainer.innerHTML = r['html'];
            Load.push_url(el.href);
        }).catch(() => {
            Lightbox.close();
        });
    }

    static push_url(url)
    {
        window.history.replaceState({v: url}, document.title, url);
    }
}

class Lightbox
{
    constructor(el, type)
    {
        this.parentEl = el;
        this.lb = this.build_lightbox(type);
        this.add_close(this.lb);
        this.activeFacsimileNo = 0;
        this.facsimiles = {};

        switch(type)
        {
            case 'cover':
                this.load_cover(el.src);
                break;

            case 'facsimile':
                this.get_facsimileData(true);
                break;

            case 'nav':
                this.get_facsimileData(false);
                this.switch_facsimile(el);
                break;

            case 'text':
                this.load_text(el.href);
                break;
        }

    }

    build_lightbox()
    {
        // remove exisiting lightbox
        let lb = document.body.querySelector('.w__lightbox');

        if(!lb)
        {
            lb = document.createElement('div');
            lb.classList.add('w__lightbox');
            document.body.appendChild(lb);
        }

        document.body.classList.add('w__lightbox--active');

        return lb;
    }

    add_navigation(parentEl)
    {
        const navContainer = document.createElement('div'),
              navPrev = document.createElement('span'),
              navNext = document.createElement('span');
        navContainer.classList.add('w__lightbox--nav-container');
        navPrev.className = 'w__lightbox--nav prev';
        navNext.className = 'w__lightbox--nav next';
        navPrev.addEventListener('click',e => {this.switch_facsimile(e.target)});
        navNext.addEventListener('click',e => {this.switch_facsimile(e.target)});
        navContainer.appendChild(navPrev);
        navContainer.appendChild(navNext);
        parentEl.appendChild(navContainer);
    }

    add_close(parentEl)
    {
        const closeContainer = document.createElement('span');
        closeContainer.classList.add('w__lightbox--close');
        closeContainer.classList.add('w__js-button');
        closeContainer.dataset.f = 'lightbox-close';
        switch(w_lang)
        {
            case 'cs':
                closeContainer.title = 'Zavřít';
                break;

            case 'de':
                closeContainer.title = 'Schließen';
                break;

            case 'en':
                closeContainer.title = 'Close';
                break;

            case 'sk':
                closeContainer.title = 'Zatvoriť';
                break;
        }
        parentEl.appendChild(closeContainer);
    }

    get_facsimileData(load)
    {
        const facsimileSource = document.body.querySelector('.w__article--facsimile-source');
        if(facsimileSource)
        {
            this.facsimiles = facsimileSource.querySelectorAll('.w__article--facsimile-item');
            this.activeFacsimileNo = 0;

            if(load === true)
            {
                Load.push_url(this.parentEl.href);
                this.load_facsimile();
            }
        }
    }

    load_facsimile()
    {
        const maxWidth = get_elInfo(document.getElementById('w--content'))['width'] - 60;
        document.documentElement.classList.add('w__waiting');
        const newImage = new Image();
        newImage.src = adjust_imagePath(this.facsimiles[this.activeFacsimileNo].href, maxWidth);
        newImage.className = 'w__lightbox--image';
        newImage.addEventListener('load',() =>
        {
            document.documentElement.classList.remove('w__waiting');
            const coverContainer = this.add_container(),
                  figure = document.createElement('figure');
            figure.appendChild(newImage);
            if(this.facsimiles[this.activeFacsimileNo].textContent)
            {
                const caption = document.createElement('figcaption');
                caption.classList.add('w__lightbox--caption');
                caption.textContent = this.facsimiles[this.activeFacsimileNo].textContent;
                figure.appendChild(caption);
            }
            if(this.facsimiles.length > 1)
            {
                this.add_navigation(coverContainer);
            }
            coverContainer.appendChild(figure);
        });
    }

    switch_facsimile(el)
    {
        if(el && el.classList.contains('prev'))
        {
            this.activeFacsimileNo--;
            if(this.activeFacsimileNo < 0)
            {
                this.activeFacsimileNo = this.facsimiles.length - 1;
            }
        }
        else if(el && el.classList.contains('next'))
        {
            this.activeFacsimileNo++;
            if(this.activeFacsimileNo >= this.facsimiles.length)
            {
                this.activeFacsimileNo = 0;
            }
        }
        this.load_facsimile();
    }

    load_cover(src)
    {
        const maxWidth = get_elInfo(document.getElementById('w--content'))['width'] - 60;
        document.documentElement.classList.add('w__waiting');
        const newImage = new Image();
        newImage.src = adjust_imagePath(src, maxWidth);
        newImage.className = 'w__lightbox--image';
        newImage.addEventListener('load',() =>
        {
            document.documentElement.classList.remove('w__waiting');
            const coverContainer = this.add_container();
            coverContainer.appendChild(newImage);
            Load.push_url(document.location + '/cover');
        });
    }

    load_text(url)
    {
        Load.do_request({f: 'text', url: url}).then(r => {
            const textContainer = this.add_container();
            if(r['function'])
            {
                textContainer.classList.add(r['function']);
            }
            textContainer.innerHTML = r['html'];
            Load.push_url(url);
        }).catch(r => {
            Lightbox.close();
            console.log(r);
        });
    }

    add_container()
    {
        let container = this.lb.querySelector('.w__lightbox--inner');
        if(container)
        {
            container.innerHTML = '';
        }
        else
        {
            container = document.createElement('div');
            container.classList.add('w__lightbox--inner');
            this.lb.appendChild(container);
        }

        return container;
    }

    static close()
    {
        const lb = document.body.querySelector('.w__lightbox');

        if(lb)
        {
            document.body.classList.remove('w__lightbox--active');
            lb.remove();

            const dirs = document.location.pathname.split('/');
            let newUrl = '';
            for(let i=1; i<(dirs.length - 1); i++)
            {
                newUrl +=  '/' + dirs[i];
            }
            Load.push_url(newUrl);
        }
    }
}

class Search
{
    constructor()
    {
        this.container = document.body.querySelector('.w__module--interactive');
    }

    search()
    {
        const fields = {};
        let topic = this.container.querySelector('select[name="topic"]'),
            keyword = this.container.querySelector('input[name="keyword"]'),
            periodStart = this.container.querySelector('input[name="period-start"]'),
            periodEnd = this.container.querySelector('input[name="period-end"]'),
            ok = true;

        if(topic && topic.value.match(/^[0-9]+$/))
        {
            fields.topicId = topic.value;
        }

        if(keyword && keyword.value.trim().length >= 2)
        {
            this.remove_error(keyword);
            fields.keyword = keyword.value;
        }
        else if(keyword)
        {
            this.add_error(keyword);
            ok = false;
        }

        if(periodStart && periodStart.value.match(/^[0-2][0-9][0-9][0-9]-[0-1][0-9]-[0-3][0-9]$/))
        {
            this.remove_error(periodStart);
            fields.dateStart = periodStart.value;
        }
        else if(periodStart && periodStart.value)
        {
            this.add_error(periodStart);
            ok = false;
        }

        if(periodEnd && periodEnd.value.match(/^[0-2][0-9][0-9][0-9]-[0-1][0-9]-[0-3][0-9]$/))
        {
            this.remove_error(periodEnd);
            fields.dateEnd = periodEnd.value;
        }
        else if(periodEnd && periodEnd.value)
        {
            this.add_error(periodEnd);
            ok = false;
        }

        if(periodStart && periodEnd &&
           periodStart.value && periodEnd.value &&
           periodStart.value > periodEnd.value)
        {
            this.add_error(periodStart);
            ok = false;
        }

        if(ok === true)
        {
            this.container.querySelector('.w__search--form').submit();
        }
    }

    add_error(el)
    {
        el.closest('p').classList.add('w__error');
    }

    remove_error(el)
    {
        el.closest('p').classList.remove('w__error');
    }
}


const get_iFrame = function(mySrc, myClass)
{
    const myIframe = document.createElement('iframe');
    myIframe.src = mySrc;
    myIframe.classList.add(myClass);
    myIframe.frameborder = 0;
    myIframe.allowfullscreen = 1;
    myIframe.setAttribute('allow', 'autoplay; fullscreen');
    return myIframe;
};

const get_iFrameSrc = function(el)
{
    let url = el.href;
    switch(el.dataset.type)
    {
        case 'youtube':
            url = 'https://www.youtube-nocookie.com/embed/' +
                el.dataset.code +
                '?showinfo=0' +
                '&controls=1' +
                '&fs=1' +
                '&rel=0' +
                '&hl=' + w_lang +
                '&autoplay=1' +
                '&modestbranding=1' +
                '&showsearch=0'
            break;

        case 'vimeo':
            url = 'https://player.vimeo.com/video/' + el.dataset.code + '?autoplay=1&badge=0&byline=0&portrait=0&title=0';//&dnt=1';
            break;

        default:
            alert('Unknown video type');
    }
    return url;
}

const show_video = function(el)
{
    const p = el.closest('p');
    const iFrame = get_iFrame(get_iFrameSrc(el),'w__video--iframe');
    p.innerHTML = '';
    p.classList.add('w__video--link');
    p.appendChild(iFrame);
};

/**
 * adjust path (size) for dynamically loaded images
 */
const adjust_imagePath = function(imgSrc, sizeX)
{
    let targetPath;
    sizeX *= w_myScreen.highDpi;

    if(imgSrc.match(/\/cover\//))
    {
        if(sizeX <= 300)
        {
            targetPath = '300';
        }
        else if(sizeX <= 600)
        {
            targetPath = '600';
        }
        else if(sizeX <= 900)
        {
            targetPath = '900';
        }
        else
        {
            targetPath = '1200';
        }
        imgSrc = imgSrc.replace('/cover/300/', '/cover/' + targetPath + '/');
    }
    else if(imgSrc.match(/\/facsimile\//))
    {
        if(sizeX <= 300)
        {
            targetPath = '300px';
        }
        else if(sizeX <= 600)
        {
            targetPath = '600px';
        }
        else if(sizeX <= 900)
        {
            targetPath = '900px';
        }
        else
        {
            targetPath = '1200px';
        }
        imgSrc = imgSrc.replace('/facsimile/900px/', '/facsimile/' + targetPath + '/');
    }

    return imgSrc;
};

/**
 * analyze browser engine, os and mobile
 */
const get_browser = function()
{
    w_myBrowser.mobile = false;

    if(navigator.vendor && navigator.vendor.match(/google/i))
    {
        w_myBrowser.engine = 'blink';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*chrome\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.vendor && navigator.vendor.match(/apple/i))
    {
        w_myBrowser.engine = 'webkit';
        w_myBrowser.version = parseFloat(navigator.userAgent.replace(/.*version\/([1-9][0-9]*(\.[1-9])?).*/i,'$1'));
    }
    else if(navigator.userAgent.match(/firefox\//i))
    {
        w_myBrowser.engine = 'gecko';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*firefox\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/edge\//i))
    {
        w_myBrowser.engine = 'edgehtml';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*edge\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/trident\//i))
    {
        w_myBrowser.engine = 'trident';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*trident\/([1-9][0-9]*)\..*/i,'$1')) + 4;
    }

    switch(navigator.platform.toLowerCase())
    {
        case 'win32':
            w_myBrowser.os = 'windows';
            break;

        case 'macintel':
            // detect iOS on iPadOS/Safari 13
            if(navigator.maxTouchPoints > 1)
            {
                w_myBrowser.os = 'ios';
                w_myBrowser.mobile = true;
            }
            else
            {
                w_myBrowser.os = 'osx';
            }
            break;

        case 'ipad':
        case 'iphone':
            w_myBrowser.os = 'ios';
            w_myBrowser.mobile = true;
            break;

        default:
            if(navigator.userAgent.match(/android/i))
            {
                w_myBrowser.os = 'android';
                w_myBrowser.mobile = true;
            }
            else if(navigator.platform.match(/linux/i))
            {
                w_myBrowser.os = 'linux';
            }
    }
};

/**
 * returns element dimensions and positions
 *
 * @param el
 * @returns {ClientRect | DOMRect}

 const get_elementInfo = function(el)
 {
    return el.getBoundingClientRect(document.body);
};
 */

/**
 * Measures and stores various screen parameters
 */
const get_screenSize = function()
{
    // pixel density
    w_myScreen.highDpi = window.devicePixelRatio ? window.devicePixelRatio : 1;
    if(w_myScreen.highDpi > 2)
    {
        w_myScreen.highDpi = 2;
    }

    // screen size
    if(w_myBrowser.mobile === true)
    {
        w_myScreen.x = window.innerWidth;
        w_myScreen.y = window.innerHeight;
    }
    else
    {
        w_myScreen.x = document.body.clientWidth;
        w_myScreen.y = window.innerHeight;
    }

    switch(parseInt(window.getComputedStyle(document.body).getPropertyValue('border-bottom-color').substr(4,1)))
    {
        case 1:
            w_myScreen.layout = 'tablet';
            break;
        case 2:
            w_myScreen.layout = 'smartphone';
            break;

        default:
            w_myScreen.layout = 'desktop';
    }

    switch(parseInt(window.getComputedStyle(document.body).getPropertyValue('border-top-color').substr(4,1)))
    {
        case 1:
            w_myScreen.orientation = 'portrait';
            break;

        default:
            w_myScreen.orientation = 'landscape';
    }
};

const get_elInfo = function(el)
{
    return el.getBoundingClientRect(document.body);
};

/*
window.onpopstate = function(e)
{
    if(e.state !== null)
    {
        //const myUrl = newLoc.split('#');
        //newLoc = myUrl[0];
        if(e.state.v)
        {
            Load.do_request({f: 'history', url: e.state.v});
        }
    }
};
*/

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(w_resizeTimer);
    w_resizeTimer = requestAnimationFrame(get_screenSize);
});